import { render, staticRenderFns } from "./UploadForm.vue?vue&type=template&id=44e35edb&scoped=true&"
import script from "./UploadForm.vue?vue&type=script&lang=js&"
export * from "./UploadForm.vue?vue&type=script&lang=js&"
import style0 from "./UploadForm.vue?vue&type=style&index=0&id=44e35edb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e35edb",
  null
  
)

export default component.exports